// export const EDIT_PROFILE = "EDIT_PROFILE"
// export const PROFILE_SUCCESS = "PROFILE_SUCCESS"
// export const PROFILE_ERROR = "PROFILE_ERROR"
// export const RESET_PROFILE_FLAG = "RESET_PROFILE_FLAG"

export const GET_PROFILE_START = "GET_PROFILE_START"
export const GET_PROFILE_SUCCESS = "GET_PROFILE_SUCCESS"
export const GET_PROFILE_ERROR = " GET_PROFILE_ERROR"
export const GET_PROFILE_RESET = "GET_PROFILE_RESET"

export const CREATE_PROFILE_START = "CREATE_PROFILE_START"
export const CREATE_PROFILE_SUCCESS = "CREATE_PROFILE_SUCCESS"
export const CREATE_PROFILE_ERROR = "CREATE_PROFILE_ERROR"
export const CREATE_PROFILE_RESET = "CREATE_PROFILE_RESET"
